// extracted by mini-css-extract-plugin
export default {"muChList":"testOptions_muChList__Vcw6p","muChOptions":"testOptions_muChOptions__SghKD","muChAnswer":"testOptions_muChAnswer__scN2Q"};